import { EmployeeDto, EmployeesInfiniteResponseDto } from './workforce-service.dto';
import {
  employeeObjectSchema,
  EmployeePayload,
  EmployeeResponse,
  EmployeesInfiniteResponse,
  employeesInfiniteResponseSchema,
} from './workforce-service.types';
import { OgpApiService } from '../../../ogp/services/ogp-api-service';

export class WorkforceService {
  constructor(private readonly ogpApiService: OgpApiService) {}

  public getEmployees = async ({
    pageParam,
  }: {
    pageParam: number;
  }): Promise<EmployeesInfiniteResponse> => {
    const value = await this.getEmployeesImpl({ pageParam });
    return employeesInfiniteResponseSchema.parse(value);
  };

  public getEmployee = async (employeeId: string): Promise<EmployeeResponse> => {
    const value = await this.getEmployeeImpl(employeeId);
    return employeeObjectSchema.parse(value);
  };

  private getEmployeeImpl = async (employeeId: string) => {
    return await this.ogpApiService.get<EmployeeDto>({
      path: `workforce/${employeeId}`,
    });
  };

  private getEmployeesImpl = async ({ pageParam }: { pageParam: number }) => {
    return await this.ogpApiService.get<EmployeesInfiniteResponseDto>({
      path: 'workforce',
      params: {
        page: pageParam,
        pageSize: 25,
      },
    });
  };

  public createEmployee = async (employeeData: EmployeePayload): Promise<string> => {
    return await this.ogpApiService.create<string>({
      path: `workforce`,
      body: employeeData,
    });
  };
}
